<template>
  <svg class="icon" viewBox="0 0 22 21">
    <g id="Symbols" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square">
      <g id="Cart-Slideout" transform="translate(-549.000000, -33.000000)" :stroke="stroke">
        <g id="icon--cross" transform="translate(548.000000, 32.000000)">
          <g id="Line-2">
            <path d="M1.5625,1.5625 L21.9350075,21.9350075" fill-rule="nonzero"></path>
            <path d="M1.5625,21.9350075 L21.9350075,1.5625" fill-rule="nonzero"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconClose',
  props: {
    stroke: {
      default: '#1C1C1C',
      type: String
    }
  }
}
</script>
